export default __webpack_public_path__ + "static/article-how-rewards-credit-cards-are-devaluing-6fd9bf0132325c68e1f5507b8ee589a0.jpg";